import React, { FC } from 'react';
import Text, { TextType } from '../../../../../../../../Components/Text';
import { BookingDTO } from '../../../../../../../../../../types';
import { BookingBodyContentAddressDataHooks } from '../../../../../../../datahooks';

export interface BookingBodyContentAddressProps {
  booking: BookingDTO;
}

const BookingBodyContentAddress: FC<BookingBodyContentAddressProps> = ({
  booking,
}) => {
  return (
    <div data-hook={BookingBodyContentAddressDataHooks.Main}>
      <Text
        data-hook={BookingBodyContentAddressDataHooks.Text}
        type={TextType.Primary}
      >
        {booking.locationInfo}
      </Text>
    </div>
  );
};

export default BookingBodyContentAddress;
